import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { leaderBoardsKeys } from '../api/leaderBoardsKeys';
import type { ILeaderBoardResponse } from '../types/ILeaderBoardResponse';
const SOCKET_TIMEOUT_MS = 5000;
const processSnapshot = (data: ILeaderBoardResponse): ILeaderBoardResponse => {
  const [hours, minutes, seconds] = data.timeUntilEnd.split(':').map(Number);
  const timeUntilEndMs = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
  return {
    ...data,
    endDateTime: new Date(Date.now() + timeUntilEndMs).toISOString()
  };
};
export const useLeaderboardLiveData = () => {
  const $ = _c(10);
  const queryClient = useQueryClient();
  const [isTimeout, setIsTimeout] = useState(false);
  let t0;
  if ($[0] !== queryClient) {
    t0 = () => {
      const cachedRaw = queryClient.getQueryData(leaderBoardsKeys.global());
      return cachedRaw ? processSnapshot(cachedRaw) : null;
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [liveData, setLiveData] = useState(t0);
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const timer = setTimeout(() => setIsTimeout(true), SOCKET_TIMEOUT_MS);
      return () => clearTimeout(timer);
    };
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== queryClient) {
    t3 = () => queryClient.getQueryCache().subscribe(event => {
      if (event.type !== "updated" || JSON.stringify(event.query.queryKey) !== JSON.stringify(leaderBoardsKeys.global())) {
        return;
      }
      const data = event.query.state.data as ILeaderBoardResponse | undefined;
      if (data) {
        setLiveData(processSnapshot(data));
      }
    });
    t4 = [queryClient];
    $[4] = queryClient;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  const t5 = liveData === null && !isTimeout;
  let t6;
  if ($[7] !== liveData || $[8] !== t5) {
    t6 = {
      liveData,
      isLoading: t5
    };
    $[7] = liveData;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};